import { render } from "./ProjectCompaniesSummary.vue?vue&type=template&id=312b17d4&ts=true"
import script from "./ProjectCompaniesSummary.vue?vue&type=script&lang=ts"
export * from "./ProjectCompaniesSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__